/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Locations API
 * AV Services Locations management API
 * OpenAPI spec version: 1.0
 */

/**
 * Alert status of the space
 */
export type AlertStatus = (typeof AlertStatus)[keyof typeof AlertStatus];

export const AlertStatus = {
  UNKNOWN: 'unknown',
  OK: 'ok',
  INWARNING: 'inWarning',
  INALERT: 'inAlert',
} as const;
